import api from '../config/axiosConfig';

export const PerfilService = {
    fetchPerfiles: async (token) => {
        try {
            const response = await api.get('/ajustes/perfiles', {
                headers: { Authorization: `Bearer ${token}` },
            });

            return response.data.perfiles || [];
        } catch (error) {
            console.error('Error en PerfilService.fetchPerfiles:', error);
            throw error;
        }
    },
    guardarPerfil: async ({ token, formData, editingItem }) => {
        try {
            if (editingItem) {
                await api.put(`/ajustes/perfiles/${editingItem.id}`,
                    formData,
                    {
                        headers: { Authorization: `Bearer ${token}` },
                    }
                );
            } else {
                await api.post('/ajustes/perfiles', formData, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            }
        } catch (error) {
            console.error('Error en PerfilService.guardarPerfil:', error);
            throw error;
        }
    },
    getPermisos: async (token) => {
        try {
            const response = await api.get('/ajustes/permisos', {
                headers: { Authorization: `Bearer ${token}` },
            });

            return response.data.permisos || [];
        } catch (error) {
            console.error('Error en PerfilService.getPermisos:', error);
            throw error;
        }
    },
    getPermisosByPerfil: async (token, perfilId) => {
        try {
            const response = await api.get(`/ajustes/perfiles/${perfilId}/permisos`, {
                headers: { Authorization: `Bearer ${token}` },
            });

            return response.data.permisosPerfil || [];
        } catch (error) {
            console.error('Error en PerfilService.getPermisosByPerfil:', error);
            throw error;
        }
    },
    guardarPermisos: async (token, formData, perfilId) => {
        try {
            await api.put(`/ajustes/perfiles/${perfilId}/permisos`,
                formData,
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );
        } catch (error) {
            console.error('Error en PerfilService.guardarPermisos:', error);
            throw error;
        }
    },
};
